module.exports = __webpack_public_path__ + "img/Vector.3390ca86.png";